// extracted by mini-css-extract-plugin
module.exports = {"playerSize":"playerSize--TqIfs","playerContainer":"playerContainer--30Odf"};